import React from "react"
import { Loader, White, Blue, LoadingContainer } from "./LoadingStyled"
import { ReactComponent as WhiteSvg } from "./svg/white.svg"
import { ReactComponent as BlueSvg } from "./svg/blue.svg"



export default function Loading({ duration }) {
  return (
    <LoadingContainer >
      <Loader>
        <White>
          <WhiteSvg />
        </White>
        <Blue duration={duration}>
          <BlueSvg />
        </Blue>
      </Loader>
    </LoadingContainer>
  )
}
